import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { dayjs, utils } from 'passiv-libs'
import { Container, Text, Row, Mobiscroll } from 'passiv-components'

let min = ''
let max = ''

const Away = ({
  start,
  end,
  isAway,
  isAwayInFuture,
  onToggle,
  onToggleRow,
  onChange,
  onDelete,
  onSave
}) => {
  useEffect(() => {
    min = dayjs().format('YYYY-MM-DD')
    max = dayjs(end.value).add(10, 'year').format('YYYY-MM-DD')
    utils.settings.setPortalWindowStatus(true)
  }, [])

  const buttons = []

  if (isAway || isAwayInFuture) {
    buttons.push({
      text: 'Delete',
      colour: 'in-red',
      icon: 'trash',
      onClick: onDelete
    })
  }

  buttons.push({
    text: 'Cancel',
    onClick: onToggle
  })

  buttons.push({
    text: 'Save',
    disabled: dayjs(end.value).isBefore(start.value) || dayjs(end.value).isSame(start.value),
    onClick: onSave
  })

  return (
    <Container.Inner dataContainer={`dashboard-away`} title="Away" titleCenter={false} open={true} buttons={buttons}>
      <Text type="title" className="bg-grey-bg p-2 text-grey border-b border-border-light">
        How long will you be away?
      </Text>
      <Row
        name="starts"
        open={start.open}
        right={dayjs(start.value).format('h.mma, D MMM YYYY')}
        text="Starts"
        subTextPosition="bottom"
        selected={true}
        onClick={() => onToggleRow({ id: 'start' })}
      >
        <div aria-hidden="true">
          <Mobiscroll.Date
            name="start"
            value={start.value}
            minDate={min}
            maxDate={max}
            format="DD MMMM YYYY"
            onChange={({ name, date }) => onChange({ id: name, value: date, type: 'date' })}
          />
          <Mobiscroll.TimeCustom
            name="start"
            value={start.value}
            onChange={({ name, time }) => onChange({ id: name, value: time, type: 'time' })}
          />
        </div>
      </Row>

      <Row
        name="ends"
        open={end.open}
        right={dayjs(end.value).format('h.mma, D MMM YYYY')}
        text="Ends"
        subTextPosition="bottom"
        selected={true}
        borders={start.open ? ['bottom', 'top'] : ['bottom']}
        onClick={() => onToggleRow({ id: 'end' })}
      >
        <div aria-hidden="true">
          <Mobiscroll.Date
            name="end"
            value={end.value}
            minDate={min}
            maxDate={max}
            format="DD MMMM YYYY"
            onChange={({ name, date }) => onChange({ id: name, value: date, type: 'date' })}
          />
          <Mobiscroll.TimeCustom
            name="end"
            value={end.value}
            onChange={({ name, time }) => onChange({ id: name, value: time, type: 'time' })}
          />
        </div>  
      </Row>
    </Container.Inner>
  )
}

Away.propTypes = {
  loading: PropTypes.bool,
  start: PropTypes.object,
  end: PropTypes.object,
  isAway: PropTypes.bool,
  onToggle: PropTypes.func,
  onToggleRow: PropTypes.func,
  onChange: PropTypes.func,
  onDelete: PropTypes.func,
  onSave: PropTypes.func
}

export default Away
